// extracted by mini-css-extract-plugin
export default {"spinner":"SpinnerLoader__spinner___aT1CI","loading-spin":"SpinnerLoader__loading-spin___t6dAR"};